import api from './api';

const asBlob = (url) => api.get(url, { responseType: 'blob' });

export const exportProjectPdf = (projectId) => asBlob(`/export/projects/${projectId}/report.pdf`);

export const exportProjectXlsx = (projectId) => asBlob(`/export/projects/${projectId}/report.xlsx`);

export const exportDelaysXlsx = (params = {}) => api.get('/export/delays.xlsx', { params, responseType: 'blob' });

export const exportPerformanceXlsx = (scope, entityId, month) =>
  api.get(`/export/performance/${scope}/${entityId}.xlsx`, { params: month ? { month } : {}, responseType: 'blob' });

export const exportNcrPdf = (ncrId) => asBlob(`/export/ncr/${ncrId}.pdf`);
